<template>
  <div>
    <vs-row>
      <vs-col class="">
        <h5 class="mb-4">구성원 요청사항</h5>
      </vs-col>
    </vs-row>
    <vs-row class="mb-4">
      <vs-col class="w-1/2 pr-1 mb-2" >
        <vs-button class="w-full" color="secondary" @click="handleClickUpdate">수정</vs-button>
      </vs-col>
      <vs-col v-if="enableReply" class="w-1/2 pl-1 mb-2" >
        <vs-button class="w-full" color="secondary" type="border" @click="handleClickReply">답글</vs-button>
      </vs-col>
      <vs-col v-else class="w-1/2 pl-1 mb-2" > </vs-col>
      <vs-col class="w-1/2 pr-1 mb-2" >
        <vs-button class="w-full" color="secondary" type="border" @click="handleClickList">목록</vs-button>
      </vs-col>
      <vs-col class="w-1/2 pl-1 mb-2" >
        <vs-button class="w-full" color="secondary" @click="handleClickRegister">글쓰기</vs-button>
      </vs-col>
    </vs-row>

    <vx-card class="mb-8">
      <vs-row>
        <vs-col class="">
          <h5 class="mb-4"><i class="dot"></i>구성원 요청사항</h5>
        </vs-col>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col class="flex flex-wrap">
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 70px 1fr;">
            <vs-col>제목</vs-col>
            <vs-col><span class="w-full">{{ post.post_title}}</span></vs-col>
          </vs-row>
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 70px 1fr;">
            <vs-col>작성자</vs-col>
            <vs-col><span class="w-full">{{ (post.author) ? post.author.name : '' }}</span></vs-col>
          </vs-row>
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 70px 1fr;">
            <vs-col>작성일</vs-col>
            <vs-col><span class="w-full">{{ post.created_at }}</span></vs-col>
          </vs-row>
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 70px 1fr;">
            <vs-col>내용</vs-col>
            <vs-col><span class="w-full" v-html="form.content"></span></vs-col>
          </vs-row>
        </vs-col>
      </vs-row>


      <file-upload-module v-if="fileList.length > 0" class="w-full" v-model="fileList" type="check_list_col" :readonly="true"></file-upload-module>

    </vx-card>

    <vx-card class="mb-8 p-0">

      <div :data="comment" :key="index" v-for="(comment, index) in comments"
           class="comment-item" :class="`comment-item-${index}`" :style="{paddingLeft : (1.0 * (comment.dep - 1))+'rem'}">
        <div class="flex">
          <vs-icon v-if="comment.dep > 0" style="width: 30px;" icon-pack="feather" icon="icon-corner-down-right"></vs-icon>
          <div>
            <vs-row class="comment-view " :class="(index == comments.length -1) ? 'mb-0' : 'mb-4'">
              <vs-col>
                <vs-row class="comment-view-body grid" style="grid-template-columns: 32px 1fr;">
                  <vs-col class="col-img" >
                    <vs-images hover="zoom" >
                      <vs-image :src="comment.user_avatar" style="width:32px; height:32px;"></vs-image>
                    </vs-images>
                  </vs-col>
                  <vs-col class="pl-4" vs-type="grid" vs-align="center">
                    <vs-col >
                      <span>{{comment.user_name}}</span>
                      <span class="ml-8">{{comment.created_at}}</span>
                    </vs-col>
                  </vs-col>
                </vs-row>
                <vs-row class="my-6">
                  <vs-col>{{comment.comment_content}}</vs-col>
                </vs-row>
              </vs-col>
              <vs-col v-if="comment.user_id === activeUserId" class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
                <a href="javascript:;" @click="(event)=>{ openWrite(event, index) }">답글</a>
                <span class="mx-2">|</span>
                <a href="javascript:;" @click="(event)=>{ openUpdate(event, index, comment.comment_content) }">수정</a>
                <span class="mx-2">|</span>
                <a href="javascript:;" @click="(event)=>{ handleClickDeleteComment(comment.comment_id) }">삭제</a>
              </vs-col>
              <vs-col
                v-else
                class="col-fix-buttons " vs-type="flex" vs-align="center" vs-justify="flex-end">
                <vs-button class="mr-2" color="#eaeaea" text-color="black" @click="(event)=>{ openWrite(event, index) }">답글</vs-button>
              </vs-col>
            </vs-row>

            <vs-row class="comment-write" vs-type="flex">

              <vs-textarea class="w-full" rows="2" v-model="subComment[index]"/>
              <vs-button class="ml-auto mr-2" color="secondary" @click="(event)=>{ handleClickAddSubComment(index, comment.comment_id) }">
                <span v-if="subCommentType[index] === 'u'">수정</span>
                <span v-else>등록</span>
              </vs-button>
              <vs-button type="border" @click="(event)=>{ closeWrite(index) }">취소</vs-button>
            </vs-row>
          </div>
        </div>

      </div>

    </vx-card>

    <!-- 댓글 달기 -->
    <vx-card class="p-0 mb-wide">
      <vs-row class="flex" vs-justify="flex-end">
        <vs-col class="w-full">
          <vs-textarea class="mb-0" rows="3" v-model="comment"/>
        </vs-col>
        <vs-col class="col-fix-buttons mt-2" style="display:flex; justify-content: flex-end">
          <vs-button color="secondary" @click="(event)=>{ handleClickAddComment(this.comment, 0) }">등록하기</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import FileUploadModule from '@/views/modules/FileUploadModule'
export default {
  name: 'MobileCommunityUnitBusinessNewsDetail',
  components: {FileUploadModule},
  data () {
    return {
      rootPath: '', // 프로젝트의 rootPath
      boardSlug: 'field_news',
      boardId: 19,
      post:{},
      form: {
        title: '', //사무소명
        writer: '', //작성자
        content: ''
      },
      fileList: [],
      comment:'',
      comments: [],
      subComment:[],
      subCommentType:[],
      enableReply:true
    }
  },

  computed: {
    isAuthor () {
      if (this.form.writer && this.activeUserInfo) {
        const postAuthorId = this.form.writer.id
        const userId = this.activeUserInfo.id
        return postAuthorId === userId
      }

      return false
    },

    activeUserId () {
      return this.$store.state.auth.userInfo.id
    }
  },

  created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}/${paths[3]}`

    this.loadPost()
    this.loadCommentList()
  },

  methods:{
    async loadPost () {
      const boardId = this.boardId
      const postId = this.$route.params.postId
      await this.$store.dispatch('board/LOAD_POST', {boardId, postId})

      // 내용
      this.post = this.$store.state.board.postInfo
      this.fileList = []
      for (const file of this.post.post_attachment) {
        this.fileList.push({
          id:file.id,
          fileName:file.file_name,
          fileSize:file.file_size,
          path:file.path
        })
      }
      this.enableReply = !(this.post.post_parent_id > 0)
      this.form = JSON.parse(this.post.post_content)
    },


    async loadCommentList () {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId

      await this.$store.dispatch('board/LOAD_COMMENT_LIST', {boardSlug, postId})
      this.comments = this.$store.state.board.commentList

    },

    handleClickUpdate () {
      const postId = this.$route.params.postId
      this.$router.push({path: `${this.rootPath}/content/community/unitbusinessnews/${postId}/update`})
    },

    handleClickList () {
      this.$router.push({path: `${this.rootPath}/content/community/unitbusinessnews/`})
    },

    handleClickRegister () {
      this.$router.push({path: `${this.rootPath}/content/community/unitbusinessnews/create`})
    },

    handleClickReply () {
      const postId = this.$route.params.postId
      this.$router.push({path: `${this.rootPath}/content/community/unitbusinessnews/${postId}/reply`})
    },

    handleClickAddComment (comment, parentId) {
      this.addComment(comment, parentId)
    },

    handleClickAddSubComment (index, commendId) {
      const comment = this.subComment[index]
      const parentId = commendId
      const addCommentType = this.subCommentType[index]

      if (addCommentType === 'c') {
        this.addComment(comment, parentId)
      }
      if (addCommentType === 'u') {
        this.updateComment(comment, commendId)
      }
      this.closeWrite(index)
    },

    handleClickUpdateComment (comment, commentId) {
      this.updateComment(comment, commentId)
    },

    handleClickDeleteComment (commentId) {
      this.deleteComment(commentId)
    },

    // 댓글 삭제
    async deleteComment (_commentId) {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const commentId = _commentId
      if (postId <= 0) {
        return
      }
      await this.$store.dispatch('board/DELETE_COMMENT', {boardSlug, postId, commentId})

      // 댓글 리스트 새로고침
      await this.loadCommentList()
    },

    // 댓글 추가
    async addComment (_comment, _parentId) {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const comment = _comment
      const parentId = _parentId

      await this.$store.dispatch('board/ADD_COMMENT', {boardSlug, postId, comment, parentId})

      // 댓글 리스트 새로고침
      await this.loadCommentList()
    },

    // 댓글 수정
    async updateComment (_comment, _commentId) {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const comment = _comment
      const commentId = _commentId

      await this.$store.dispatch('board/UPDATE_COMMENT', {boardSlug, postId, comment, commentId})

      // 댓글 리스트 새로고침
      await this.loadCommentList()
    },


    // 대댓글 추가
    openWrite (event, index) {
      this.subCommentType[index] = 'c'
      this.subComment[index] = ''

      const commentType = JSON.parse(JSON.stringify(this.subCommentType))
      const comment = JSON.parse(JSON.stringify(this.subComment))
      this.subCommentType = commentType
      this.subComment = comment


      const chrlen = document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children.length
      document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children[chrlen - 1].children[1].classList.add('open')
    },

    openUpdate (event, index, comments) {
      this.subCommentType[index] = 'u'
      this.subComment[index] = comments

      const commentType = JSON.parse(JSON.stringify(this.subCommentType))
      const comment = JSON.parse(JSON.stringify(this.subComment))
      this.subCommentType = commentType
      this.subComment = comment
      const chrlen = document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children.length
      document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children[chrlen - 1].children[1].classList.add('open')
    },

    // 댓글 닫기
    closeWrite (index) {
      const chrlen = document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children.length
      document.getElementsByClassName(`comment-item-${index}`)[0].children[0].children[chrlen - 1].children[1].classList.remove('open')
    }
  }
}
</script>

<style scoped>

.content-head {
  width: 100px;
  font-weight: bold;
}

.content-read {
  min-height: 20em;
  line-height: 1.6;
}

.read-layout,
.read-layout-2 {
  margin-bottom:1.5rem;
}

.read-layout {
  display: grid !important;
  grid-template-columns: 60px 1fr;
}
.read-layout-2 {
  display: grid !important;
  grid-template-columns: 60px auto 60px 1fr;
}
.read-layout-title {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.read-layout-title.top{
  align-items: start;
}

.read-layout-footer{
  width: auto !important;
  height:50px;
  display:  grid !important;
  grid-template-columns: 120px 1fr;
  align-items: center;

  margin-left:-1.5rem;
  margin-right:-1.5rem;
  border-top:1px solid #f2f2f2 !important;
}
.read-layout-footer .read-layout-title{
  height:100%;
  justify-content: center;

  background-color: #EDEDED;
}
.read-layout-footer span {
  height:100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.read-layout-footer:last-child {
  margin-bottom:-1.5rem;
}

.mb-wide { margin-bottom:1.5rem !important;}
.mb-big-wide { margin-bottom:4.5rem !important; }
.vs-button-list-left { width:auto !important; }
.vs-button-list-right { width:auto !important; margin-left:auto !important;}

b.secondary { color: rgb(102,112,203)}

.comment-item {
  border-bottom: 1px solid #EAEAEA;
  margin-bottom: 0.75rem;
}
.comment-item:last-child{
  border-bottom:none;
  margin-bottom: 0;
}


.comment-item.sub-1 {
  padding-left: 4.5rem;
}
.comment-item.sub-2 {
  padding-left: 9rem;
}
.comment-item.sub-3 {
  padding-left: 13.5rem;
}
.comment-write{
  margin-top:1.5rem;
  margin-bottom:1.5rem;

  display: none !important;
}
.comment-write.open{
  display: flex !important;
}
</style>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}

.read-vs-upload .btn-x-file {
  visibility: hidden;
}

.add-comment .vx-card__collapsible-content .vx-card__body {
  padding-right:0px !important;
}

.col-img .vs-image--img{
  background-color: #C4C4C4 !important;
}

.comment-item .con-vs-image .vs-image--img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
